<script lang="ts">
	import SecondLevelNode from './_SecondLevelNode.svelte';
	import WorldsDropdown from './_WorldsDropdown.svelte';
	import type { CmsMainNavNodeRecord, CmsWorldRecord } from '$lib/data/types';
	import { getCmsTranslationForLocale } from '$lib/cms';
	import { isMobile } from '$lib/stores';
	import { locale } from 'svelte-i18n';
	import { page } from '$app/stores';

	export let node: CmsMainNavNodeRecord;
	export let worlds: CmsWorldRecord[];

	export let isForceClosing: boolean;
	export let hoveredNode: CmsMainNavNodeRecord | null;
	export let clickedNode: CmsMainNavNodeRecord | null;
</script>

<li
	class="nav-item"
	class:nav-expand={node?.children?.length}
	class:is-current={$page.url.pathname.startsWith(`/${$locale}/${node.url}`)}
	on:mouseenter={() => (hoveredNode = isForceClosing ? null : node)}
	on:mouseleave={() => (hoveredNode = null)}
	class:is-hover={hoveredNode === node}
	class:active={clickedNode === node}
>
	<!-- svelte-ignore a11y-invalid-attribute -->
	<a
		href="#"
		class="nav-link"
		class:nav-expand-link={node.children}
		class:highlighted={node.highlighted}
		on:click|preventDefault={() => ($isMobile ? (clickedNode = node) : null)}
	>
		{getCmsTranslationForLocale(node.translations, $locale).title}
	</a>

	{#if node.children}
		<div class="nav-menu-container">
			<ul class="nav-items nav-expand-content">
				{#if $isMobile}
					<WorldsDropdown {worlds} />

					<li class="nav-item mb-0">
						<!-- svelte-ignore a11y-invalid-attribute -->
						<a
							href="#"
							class="nav-link nav-back-link"
							on:click|preventDefault={() => (clickedNode = null)}
						>
							{getCmsTranslationForLocale(node.translations, $locale).title}
						</a>
					</li>
				{/if}

				{#each node.children as middleNode}
					<SecondLevelNode node={middleNode} on:close />
				{/each}
			</ul>
		</div>
	{/if}
</li>

<style>
	.nav-item .highlighted {
		color: #004b9c;
	}

	@media (min-width: 1200px) {
		.nav-expand-link {
			color: inherit;
			background-color: #fff !important;
			border-radius: 0.25rem;
		}
	}
</style>
